import {
  PREMIUM_LEVEL_TO_QUALITY_BONUS,
  QUALITY_BONUS_TRANSLATIONS,
} from '../constants';

export const STATUS_BONUS_EXAMPLE_PRICE_EUR = 115;
export interface BonusPercent {
  Bronze: number;
  Silver: number;
  Gold: number;
}

const LEVEL_TO_NAME: Record<number, keyof BonusPercent> = {
  1: 'Bronze',
  2: 'Silver',
  3: 'Gold',
};

export function bonusPercentForLevel(
  premiumPartnerLevel: number,
  map?: BonusPercent | null,
): number {
  if (!map) {
    return 0;
  }

  const name = LEVEL_TO_NAME[premiumPartnerLevel];

  return name ? (map[name] ?? 0) : 0;
}

export interface StatusBonus {
  percent: number;
  percentLabel: number;
  amount: number;
  statusLabelKey: string;
}

export function getBonusPercent(
  premiumPartnerLevel: number,
  map?: BonusPercent | null,
): number {
  return bonusPercentForLevel(premiumPartnerLevel, map) / 100;
}

export function getStatusBonus(
  priceInEur: number,
  premiumPartnerLevel: number,
  map?: BonusPercent | null,
): StatusBonus | null {
  const percent = getBonusPercent(premiumPartnerLevel, map);

  if (!percent) {
    return null;
  }

  const qualityBonus = PREMIUM_LEVEL_TO_QUALITY_BONUS[premiumPartnerLevel];

  return {
    percent,
    percentLabel: percent * 100,
    amount: (priceInEur ?? 0) * percent,
    statusLabelKey: qualityBonus
      ? QUALITY_BONUS_TRANSLATIONS[qualityBonus]
      : '',
  };
}

export function getStatusBonusFromMinorUnits(
  bonusMinorUnits: number | null | undefined,
  premiumPartnerLevel: number,
  map?: BonusPercent | null,
  appliedPercent?: number | null,
): StatusBonus | null {
  if (bonusMinorUnits == null) {
    return null;
  }

  const percent =
    appliedPercent != null
      ? appliedPercent / 100
      : getBonusPercent(premiumPartnerLevel, map);
  const qualityBonus = PREMIUM_LEVEL_TO_QUALITY_BONUS[premiumPartnerLevel];

  return {
    percent,
    percentLabel: percent * 100,
    amount: bonusMinorUnits / 100,
    statusLabelKey: qualityBonus
      ? QUALITY_BONUS_TRANSLATIONS[qualityBonus]
      : '',
  };
}
